import {assert} from 'Asserts';

import getTestProps from './getTestProps';
import DataTestAttrs from './shared/DataTestAttrs';

/**
 * Create an HTML fragment from attributes, e.g. 'data-test-component="Modal" data-test-element="okButton"'.
 * It can then be directly inserted into the props section of HTML element text.
 *
 * This style of HTML construction is susceptible to XSS attacks, so this function should only be used for
 * legacy code that already directly builds HTML as a string. New code should use React, which doesn't have
 * this weakness.
 */
export default function testAttrsAsUnsafeHTML(attrs: Partial<DataTestAttrs> = {}): string {
  // Escaping attr values is tricky because we run into TS issues trying to import underscore into this file.
  // Instead, just assert that the values have no special characters.
  assert(
    Object.values(attrs).every((s) => /^[\w-]*$/.test(s ?? '')),
    `Invalid characters in attrs dict: ${JSON.stringify(attrs)}`
  );
  return Object.entries(getTestProps(attrs))
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');
}
